class CartRecommendationsSidebar extends HTMLElement {

	constructor() {
		super();
		this.visibleSlides = this.dataset.slides
		this.productId = this.getAttribute("data-product-id");
		this.intent = this.getAttribute("data-intent");
		this.productAction = this.getAttribute("data-product-action");
		this.limit = this.getAttribute("data-limit");
		this.store = window.themeStore;
		this.generateRecommendations();
		this.store.dataStore.listen("cart", (data) => {
			const items = data?.value?.items;

			if (!Array.isArray(items) || items.length === 0) return;

			const productId = items[0]?.product_id;
			if (!productId) return;

			this.fetchRecommendations(productId);
		});
	}

	generateRecommendations() {
		if (this.productId) {
			this.fetchRecommendations(this.productId)
			return;
		}
		this.store.data.cart.value.then((data) => {
			if (data.items.length === 0) return;
			const productId = data.items[0]["product_id"]
			this.fetchRecommendations(productId)
		})

	}

	fetchRecommendations(productId) {
		fetch(`${KROWN.settings.routes.product_recommendations_url}?section_id=cart-recommendations-sidebar&product_id=${productId}&limit=${this.limit}&intent=${this.intent}`)
			.then(response => response.text())
			.then(text => {
				const innerHTML = new DOMParser()
					.parseFromString(text, 'text/html')
					.querySelector('.cart-recommendations-sidebar');
				if (innerHTML && innerHTML.querySelectorAll('.product-item').length > 0) {
					this.innerHTML = innerHTML.innerHTML;
					const gridElement = this.querySelector('.grid');
					gridElement?.classList.add(`grid-${this.visibleSlides}`)
					const addToCart = gridElement?.querySelectorAll("button[type=addToCart]")
					if (this.productAction === "view") {
						addToCart?.forEach((button) => {
							button?.remove();
						})
					}
				}
			})
	}
}
customElements.define('cart-recommendations-sidebar', CartRecommendationsSidebar);